export type CompId = 1 | 2;

export const DEFAULT_COMP_ID: CompId = 1;

/**
 * Coerce an arbitrary value (query-string param, JSON field, etc.) into a
 * valid competition id. Anything that isn't exactly 1 or 2 falls back to the
 * default, so existing links with no comp param keep working.
 */
export function parseCompId(raw: unknown): CompId {
  const n = typeof raw === "string" ? Number(raw) : raw;
  return n === 2 ? 2 : DEFAULT_COMP_ID;
}
